import { Star } from "lucide-react";
import { useFavorites } from "@/hooks/useFavorites";

export function FavoriteButton({ toolId, className = "" }: { toolId: string; className?: string }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(toolId);

  return (
    <button
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(toolId);
      }}
      title={active ? "Remove from favorites" : "Add to favorites"}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={active}
      className={`inline-flex items-center justify-center min-h-11 min-w-11 max-sm:-mx-1.5 sm:min-h-0 sm:min-w-0 shrink-0 transition-colors ${className}`}
    >
      <Star className={`h-4 w-4 ${active ? "fill-primary text-primary" : "text-muted-foreground hover:text-foreground"}`} />
    </button>
  );
}
